import { Modal } from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
} from "../../global";
import { Row, Icon, View } from "../../Components";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { ReactComponent as xIcon } from "../../Assets/SVG/CloseSmallB.svg";
import {
  ToolTypes,
  emailVerifyStatus,
  emailVerify,
  getContacts,
  clearAlert,
  updateReport,
  clearAlerts,
  deleteAlerts,
  addAlert,
  getReports,
  getReportLogs,
} from "../../API";
import ReportColumns from "../../Components/Column/ReportColumns";
import _ from "lodash";
import {
  Paper,
  Space,
  Title,
  Divider,
  Radio,
  Button,
  Group,
  Center,
  Loader,
  Checkbox,
  Text,
  MultiSelect,
  ActionIcon,
  Table,
  SimpleGrid,
} from "@mantine/core";
import { MdOutlineFileDownload, MdOutlineRemoveRedEye } from "react-icons/md";
import { useDisclosure } from "@mantine/hooks";

let cloudRecipients = [];
let cloudFrequency = {};
let cloudEnabled = false;

function Reports() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const [addReportLoading, setAddReportLoading] = useState(false);
  const [getReportsLoading, setGetReportsLoading] = useState(false);
  const [getReportLogsLoading, setGetReportLogsLoading] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [recipients, setRecipients] = useState(
    allSites?.report?.settings?.recipientEmails
      ? allSites.report.settings.recipientEmails
      : []
  );
  const [recipientWarnings, setRecipientWarnings] = useState(
    allSites?.report?.settings?.recipientEmails
      ? allSites.report.settings.recipientEmails.map(() => "")
      : []
  );
  const [frequency, setFrequency] = useState(
    allSites?.report?.settings?.reportFrequency
      ? allSites.report.settings.reportFrequency
      : {}
  );
  const [enabled, setEnabled] = useState(
    allSites?.report?.settings?.enabled
      ? allSites.report.settings.enabled
      : false
  );
  const [reportUpdateLoading, setReportUpdateLoading] = useState(false);
  const [sendingVerification, setSendingVerification] = useState(false);
  const tempSettings = {
    reportName: "DataLogger Report",
    mac: "78E36D7664C0",
    reportProps: { channelEnable: ["sthp_temp"] },
    curDataDisplay: true,
    graphDisplay: true,
    tableDisplay: true,
    recipientEmails: ["ddavis@lab714.com"],
    reportFormat: "email",
    reportFrequency: {
      reportDaily: true,
      reportMonthly: true,
      reportWeekly: true,
    },
  };

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  function getColorByError(text) {
    switch (text) {
      case "Verified":
        return Colors.greenMain;
      case "Verify Pending":
      case "Verify Not Started":
        return Colors.orangeMain;
      case "Verify Failed":
      default:
        return Colors.redMain;
    }
  }

  function verifyButton(text, index) {
    switch (text) {
      case "Verify Pending":
      case "Verify Failed":
      case "Verify Not Started":
        return (
          <Button
            text={"Verify"}
            variant="primary"
            isLoading={sendingVerification}
            onPress={async (event) => {
              event.stopPropagation();
              setSendingVerification(true);
              await emailVerify(recipients[index])
                .then(async (res) => {
                  console.log("emailVerify:", res);
                })
                .catch((err) => {
                  console.log("emailVerify:", err);
                });
              setSendingVerification(false);
            }}
          />
        );
      case "Verified":
      default:
        return <></>;
    }
  }

  async function setEmailWarnings(emails) {
    console.log("emails:", emails);
    let tempWarnings = [];
    for (let index = 0; index < emails.length; index++) {
      const email = emails[index];
      console.log("email:", email);
      console.log("index:", index);
      if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
        tempWarnings.push("Invalid email");
      } else {
        try {
          const res = await emailVerifyStatus([email]);
          console.log("emailVerifyStatus:", res);
          if (
            res?.verificationAttributes[email]?.VerificationStatus === "Success"
          ) {
            console.log("Verified");
            tempWarnings.push("Verified");
          } else if (
            res?.verificationAttributes[email]?.VerificationStatus === "Pending"
          ) {
            console.log("Verify Pending");
            tempWarnings.push("Verify Pending");
          } else if (
            res?.verificationAttributes[email]?.VerificationStatus ===
              "Failed" ||
            res?.verificationAttributes[email]?.VerificationStatus ===
              "TemporaryFailure"
          ) {
            console.log("Verify Failed");
            tempWarnings.push("Verify Failed");
          } else {
            console.log("Verify Not Started");
            tempWarnings.push("Verify Not Started");
          }
        } catch (err) {
          console.log("emailVerifyStatus:", err);
          tempWarnings.push("Invalid email");
        }
      }
    }
    console.log("tempWarnings:", tempWarnings);
    setRecipientWarnings(tempWarnings);
  }

  useEffect(() => {
    console.log("allSites report CHANGED!");
    if (allSites?.report?.settings) {
      setRecipients(allSites.report.settings.recipientEmails);
      cloudRecipients = allSites.report.settings.recipientEmails;
      setEmailWarnings(cloudRecipients);
      setFrequency(allSites.report.settings.reportFrequency);
      cloudFrequency = allSites.report.settings.reportFrequency;
      setEnabled(allSites.report.settings.enabled);
      cloudEnabled = allSites.report.settings.enabled;
    } else {
      setRecipients([]);
      cloudRecipients = [];
      setRecipientWarnings([]);
      setFrequency({});
      cloudFrequency = {};
      setEnabled(false);
      cloudEnabled = false;
    }
  }, [allSites?.report]);

  // Fetch Reports
  const fetchReports = async () => {
    try {
      let report = null;
      let reports = await getReports()
        .then(async (res) => {
          console.log("getReports:", res);
          if (res?.Items.length > 0) {
            report = res.Items[0];
            let reportId = res.Items[0].report_id;
            let logs = await getReportLogs(reportId)
              .then(async (res) => {
                console.log("getReportLogs:", res);
                return res.Items;
              })
              .catch((err) => {
                console.log("getReportLogs:", err);
                return [];
              });
            console.log("logs:", logs);
            return logs;
          }
        })
        .catch((err) => {
          console.log("getReports:", err);
          return [];
        });

      setAllSites((prevAllSites) => ({
        ...prevAllSites,
        report,
        reports,
      }));
      console.log("Reports added to All Sites Global State", allSites);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  // On initial page load we fetch the Reports & Logs
  useEffect(() => {
    fetchReports();
  }, []);

  // Handle when user updates reports settings
  const handleSaveChanges = async (event) => {
    event.stopPropagation();
    setReportUpdateLoading(true);
    try {
      const res = await updateReport(allSites?.report?.report_id, {
        recipientEmails: recipients,
        reportFrequency: frequency,
        enabled: enabled,
      });
      console.log("updateReport:", res);
      setAllSites({
        ...allSites,
        report: {
          ...allSites.report,
          settings: {
            recipientEmails: recipients,
            reportFrequency: frequency,
            enabled: enabled,
          },
        },
      });
    } catch (err) {
      console.log("updateReport:", err);
    }
    setReportUpdateLoading(false);
  };

  // Handle when user cancels any changes made to report settings
  const handleCancelChanges = (event) => {
    event.stopPropagation();
    setRecipients(cloudRecipients);
    setEmailWarnings(cloudRecipients);
    setFrequency(cloudFrequency);
    setEnabled(cloudEnabled);
  };

  const rows = allSites.reports?.map((report, index) => {
    let date = new Date(report?.ts * 1000);
    let displayDate;
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      displayDate = `Today at ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
      displayDate = `Yesterday at ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    } else {
      displayDate = `${date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })} at ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    }

    return (
      <>
        <Table.Tr key={index}>
          <Table.Td w="50%">
            <Text size="md" ta="center">
              {displayDate}
            </Text>
          </Table.Td>
          <Table.Td w="50%">
            <Text size="md" ta="center">
              Automatic
            </Text>
          </Table.Td>
          <Table.Td>
            <Center>
              <ActionIcon
                variant="subtle"
                color="black"
                size="lg"
                
              >
                <MdOutlineRemoveRedEye size="1.7rem" />
              </ActionIcon>
            </Center>
          </Table.Td>
          <Table.Td>
            <Center>
              <ActionIcon variant="subtle" color="black" size="lg">
                <MdOutlineFileDownload size="1.7rem" />
              </ActionIcon>
            </Center>
          </Table.Td>
        </Table.Tr>
      </>
    );
  });

  return (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>Reports</Title>
          <Text c="dimmed" size="sm">
            Simplify your reporting process with scheduled emails, on-demand
            reports, and a comprehensive history log.
          </Text>
        </div>

        {allSites.report && (
          <>
            {enabled ? (
              <Button
                color={Colors.main}
                variant="outline"
                radius="sm"
                h={43}
                onClick={() => setEnabled(false)}
              >
                Turn Off Reporting
              </Button>
            ) : (
              <Button
                color={Colors.main}
                variant="outline"
                radius="sm"
                h={43}
                onClick={() => setEnabled(true)}
              >
                Turn On Reporting
              </Button>
            )}
          </>
        )}
      </Group>
      <Space h="md" />

      {allSites.report ? (
        <>
          <Paper>
            <Group justify="space-between" p="sm">
              <Title order={4} p="md">
                Settings
              </Title>

              <Button variant="default" radius="sm" h={43}>
                Send Report to Your Email
              </Button>
            </Group>

            <Divider />
            <Space h="lg" />

            {/* 
                  Add in Frequency logic
                  Possibly change the way were storing the frequency data
                  From Object -> Array
                  https://mantine.dev/core/checkbox/#checkboxgroup
              */}
            <SimpleGrid
              p="md"
              cols={{ sm: 1, lg: 2 }}
              spacing="xs"
              verticalSpacing="lg"
            >
              <MultiSelect
                label="Stores"
                placeholder="Select Stores"
                data={["1", "2", "3", "4"]}
              />
              <div>
                <Group mb="sm">
                  <Text size="sm" fw={500}>
                    Frequency
                  </Text>
                </Group>
                <Group>
                  <Checkbox
                    value="reportDaily"
                    label="Daily"
                    variant="outline"
                    color="#6D80DF"
                    styles={{
                      inner: {
                        outline: "2px solid #6D80DF",
                        outlineOffset: "-2px",
                        borderRadius: "3px",
                      },
                      label: { color: Colors.main },
                    }}
                  />
                  <Checkbox
                    value="reportWeekly"
                    label="Weekly"
                    variant="outline"
                    color="#6D80DF"
                    styles={{
                      inner: {
                        outline: "2px solid #6D80DF",
                        outlineOffset: "-2px",
                        borderRadius: "3px",
                      },
                      label: { color: Colors.main },
                    }}
                  />
                  <Checkbox
                    value="reportMonthly"
                    label="Monthly"
                    variant="outline"
                    color="#6D80DF"
                    styles={{
                      inner: {
                        outline: "2px solid #6D80DF",
                        outlineOffset: "-2px",
                        borderRadius: "3px",
                      },
                      label: { color: Colors.main },
                    }}
                  />
                </Group>
              </div>
            </SimpleGrid>
            <Space h='md'/>
            {recipients.map((email, index) => {
              return (
                <>
                  <View style={{ ...Helpers.fillRowCross }}>
                    <ActionIcon
                      ml={10}
                      color={Colors.main}
                      variant="light"
                      onClick={async (event) => {
                        event.stopPropagation();
                        let temp = _.cloneDeep(recipients);
                        let tempWarnings = _.cloneDeep(recipientWarnings);
                        temp.splice(index, 1);
                        tempWarnings.splice(index, 1);
                        setRecipients([...temp]);
                        setRecipientWarnings([...tempWarnings]);
                      }}
                    >
                      <Icon color={Colors.main} svg={xIcon} size="xs" />
                    </ActionIcon>
                    <View style={{ width: "50%" }}>
                      {/* Add Contents Back Later */}
                    </View>

                    {recipientWarnings[index] && (
                      <Paper p="xs" style={{ backgroundColor: "#F7F7F9" }}>
                        <Text
                          size="sm"
                          c={getColorByError(recipientWarnings[index])}
                        >
                          {recipientWarnings[index]}
                        </Text>
                      </Paper>
                    )}

                    {verifyButton(recipientWarnings[index], index)}
                  </View>

                  <Space h="xs" />
                </>
              );
            })}

            <Space h="xs" />

            <Group p="sm">
              <Button
                variant="default"
                onClick={(event) => {
                  event.stopPropagation();
                  setRecipients([...recipients, ""]);
                }}
              >
                <Text size="sm">Add Recipient</Text>
              </Button>
            </Group>

            {!_.isEqual(cloudRecipients, recipients) ||
              !_.isEqual(cloudFrequency, frequency) ||
              (!_.isEqual(cloudEnabled, enabled) && (
                <Group p="sm" grow>
                  <Button
                    color={Colors.main}
                    onClick={handleSaveChanges}
                    isLoading={reportUpdateLoading}
                  >
                    Save Changes
                  </Button>

                  <Button
                    variant="outline"
                    color={Colors.main}
                    onClick={handleCancelChanges}
                  >
                    Cancel
                  </Button>
                </Group>
              ))}
          </Paper>

          <Space h="md" />

          <Paper>
            <Text size="xl" p="md">
              Report History
            </Text>
            <Divider />

            <Table
              withColumnBorders
              stickyHeader
              highlightOnHover
              verticalSpacing="md"
            >
              <Table.Thead style={{ backgroundColor: "#DDDDDF" }}>
                <Table.Tr>
                  <Table.Th>
                    <Center>Time</Center>
                  </Table.Th>
                  <Table.Th>
                    <Center>Type</Center>
                  </Table.Th>
                  <Table.Th w={10}>
                    <Center>Preview</Center>
                  </Table.Th>
                  <Table.Th w={10}>
                    <Center>Download</Center>
                  </Table.Th>
                </Table.Tr>
              </Table.Thead>

              <Table.Tbody style={{ backgroundColor: "#FFFFFF" }}>
                {rows}
              </Table.Tbody>
            </Table>
          </Paper>
        </>
      ) : (
        <Center>
          <Loader color={Colors.main} />
        </Center>
      )}
    </>
  );
}

export default Reports;
